import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const ORGANIZATIONS_COLLECTION_ID = import.meta.env.VITE_ORGANIZATIONS_COLLECTION_ID;

export type Company = {
    $id: string;
    name: string;
    city: string;
    ruc: string;
    commercialName: string;
    address: string;
};

export async function fetchCompanies(): Promise<Company[]> {
    const response = await databases.listDocuments(
        DATABASE_ID,
        ORGANIZATIONS_COLLECTION_ID,
        [Query.limit(500)]
    );
    return response.documents as unknown as Company[];
}